import { create } from 'zustand';

/**
 * Worker progress for the single active solver task.
 *
 * Kept out of the application store and out of React state in `App` so that
 * frequent progress messages re-render only the components that subscribe
 * here (the processing overlay and anything needing a busy flag).
 */
export interface ProgressState {
  /** A worker task is running. */
  isProcessing: boolean;
  /** Progress of the running task, 0-100. */
  progress: number;
  /** Latest status message from the worker. */
  message: string;
}

export const IDLE_PROGRESS: ProgressState = {
  isProcessing: false,
  progress: 0,
  message: '',
};

export const useProgressStore = create<ProgressState>(() => IDLE_PROGRESS);

export const selectIsProcessing = (state: ProgressState): boolean =>
  state.isProcessing;
